import { defineTerm, getTermRange, defineRange, resolveCycleWindow, COMPASS } from '@magmacomputing/tempo/plugin-api';
import { logWarn } from '@magmacomputing/tempo/plugin-api';
import { isNumber, asArray } from '@magmacomputing/library';
/** definition of fiscal quarter ranges */
const groups = defineRange([
    { key: 'Q1', day: 1, month: 1, fiscal: 0, sphere: COMPASS.North, label: 'First Quarter' },
    { key: 'Q2', day: 1, month: 4, fiscal: 0, sphere: COMPASS.North, label: 'Second Quarter' },
    { key: 'Q3', day: 1, month: 7, fiscal: 0, sphere: COMPASS.North, label: 'Third Quarter' },
    { key: 'Q4', day: 1, month: 10, fiscal: 0, sphere: COMPASS.North, label: 'Fourth Quarter' },
    { key: 'Q1', day: 1, month: 7, fiscal: 1, sphere: COMPASS.South, label: 'First Quarter' },
    { key: 'Q2', day: 1, month: 10, fiscal: 1, sphere: COMPASS.South, label: 'Second Quarter' },
    { key: 'Q3', day: 1, month: 1, year: 1, fiscal: 0, sphere: COMPASS.South, label: 'Third Quarter' },
    { key: 'Q4', day: 1, month: 4, year: 1, fiscal: 0, sphere: COMPASS.South, label: 'Fourth Quarter' },
], 'sphere');
/** resolve the full candidate list for the current context */
function resolve(t, anchor) {
    if (t.sphere === undefined && anchor?.sphere === undefined) {
        logWarn(`[tempo] QuarterTerm requires 'sphere' configuration (e.g. Tempo.init({ sphere: 'north' }) or { sphere: 'south' }).`, t.config);
        return [];
    }
    const list = resolveCycleWindow(t, groups, { anchor, groupBy: ['sphere'] });
    list.forEach((itm) => {
        if (isNumber(itm.fiscal))
            itm.fiscal += isNumber(itm.year) ? itm.year : 0;
    });
    return list;
}
/**
 * ## QuarterTerm
 */
export const QuarterTerm = defineTerm({
    key: 'qtr',
    scope: 'quarter',
    description: 'Fiscal Quarter',
    groups,
    resolve(anchor) {
        return resolve(this, anchor);
    },
    /** determine where the current Tempo instance fits within the above range */
    define(keyOnly, anchor) {
        const res = resolve(this, anchor);
        return getTermRange(this, asArray(res), keyOnly, anchor);
    }
});
